import makeGroupedInputStyle from './makeGroupedInputStyle';

export const rightGroupedInputStyle = makeGroupedInputStyle('right');
export const leftGroupedInputStyle = makeGroupedInputStyle('left');
export const centerGroupedInputStyle = makeGroupedInputStyle('center');
